import { showNotification } from "../actionCreators/dispatchNotification";
import apiClient from "./apiClient";

const rolesUrl = '/roles/';

export const getRolesApi = async () =>
	await apiClient
		.get(rolesUrl)
		.then(res => res.data.result)
		.catch(() => showNotification('An error occurred while retrieving roles.', 'error'));